import React from "react";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import "../style.css";

const MultiplePopup = (props) => {
  const { open, onClose, selectedRecord, dialogName } = props;
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={open}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{dialogName}</Typography>
          <CloseIcon onClick={() => onClose()} style={{ cursor: "pointer" }} />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent
        dividers
        style={{ padding: "10px", height: "15em", overflowY: "scroll" }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ul>
            {selectedRecord && selectedRecord.length > 0
              ? selectedRecord[0]
                  .split(",")
                  .map((item, idx) => <li key={idx}>{item}</li>)
              : null}
          </ul>
        </div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default MultiplePopup;
